<template>
<div>
    <el-tabs v-model="activeTab" class="setting-new-tabs">
        <el-tab-pane
            v-for="item in tabsdata"
            :key="item.value"
            :label="item.label"
            :name="item.value"
        />
    </el-tabs>
    <component
        :is="currentComponent"
        ref="tabChild"
    />
</div>
</template>

<script>
import PlatFormCostSetting from '@/views/PlatFormShop/PlatFormCostSetting';
import PlatFormSetting from '@/views/PlatFormShop/PlatFormSetting';
import Banner from '@/views/Banner/Banner';
import ScheduleType from '@/views/Pets/ScheduleType';
import RecordType from '@/views/Record/RecordType';
import PlatSuperLog from '@/views/PlatFormShop/PlatSuperLog';
import EsTutarial from '@/views/EsTutarial/Tutarial';
import SystemImage from '@/views/Setting/SystemImage';

export default {
    name: 'PlatFormSettingNew',
    components: {
        PlatFormCostSetting,
        PlatFormSetting,
        Banner,
        ScheduleType,
        RecordType,
        PlatSuperLog,
        EsTutarial,
        SystemImage,
    },
    data() {
        return {
            activeTab: 1,
            tabsdata: [
                { label: '续费设置', value: 1 },
                { label: '平台设置', value: 2 },
                { label: 'banner管理', value: 3 },
                { label: '日程提醒类型', value: 4 },
                { label: '宠物记录类型', value: 5 },
                { label: '平台日志', value: 6 },
                { label: '使用教程', value: 7 },
                { label: '系统图标', value: 8 },
            ],
            labelComponentMap: {
                '续费设置': 'PlatFormCostSetting',
                '平台设置': 'PlatFormSetting',
                'banner管理': 'Banner',
                '日程提醒类型': 'ScheduleType',
                '宠物记录类型': 'RecordType',
                '平台日志': 'PlatSuperLog',
                '使用教程': 'EsTutarial',
                '系统图标': 'SystemImage',
            },
        };
    },
    computed: {
        currentComponent() {
            const tab = this.tabsdata.find((item) => item.value == this.activeTab);
            return tab ? this.getTabComponent(tab.label) : '';
        },
    },
    methods: {
        getTabComponent(label) {
            return this.labelComponentMap[label] || '';
        },
        getTabChild() {
            const child = this.$refs.tabChild;
            return Array.isArray(child) ? child[0] : child;
        },
        getHost() {
            let parent = this.$parent;
            while (parent) {
                if (typeof parent.JUMPVIEW === 'function' && typeof parent.ChildCompententAdd === 'function') {
                    return parent;
                }
                parent = parent.$parent;
            }
            return null;
        },
        findTabByComponent(name) {
            if (!name) return null;
            if (name === 'EsTutarialCate') name = 'EsTutarial';
            for (const label in this.labelComponentMap) {
                if (this.labelComponentMap[label] === name) {
                    return this.tabsdata.find((item) => item.label === label) || null;
                }
            }
            return null;
        },
        BrotherComponentIn(data) {
            const payload = data && data.param ? data.param : (data || {});
            const tab = payload.activeTab
                ? this.tabsdata.find((item) => item.value == payload.activeTab)
                : this.findTabByComponent(payload.tabComponent);
            if (tab) this.activeTab = tab.value;
            this.$nextTick(() => {
                const child = this.getTabChild();
                if (child && typeof child.BrotherComponentIn === 'function') {
                    child.BrotherComponentIn(data);
                }
            });
        },
        JUMPVIEW(data) {
            const host = this.getHost();
            if (host) host.JUMPVIEW(data);
        },
        ChildCompententAdd(item) {
            const host = this.getHost();
            if (host) host.ChildCompententAdd(item);
        },
    },
};
</script>
<style scoped>
.setting-new-tabs :deep(.el-tabs__header) {
    padding:20px 15px;
    margin-bottom: 16px;
}
.setting-new-tabs :deep(.el-tabs__item) {
    font-size: 13px;
    letter-spacing: 1px;
    color: #999;
    font-weight: normal;
}
.setting-new-tabs :deep(.el-tabs__item.is-active) {
    color: #666eeb;
    font-weight: 600;
}
.setting-new-tabs :deep(.el-tabs__active-bar) {
    background-color: #666eeb;
}
.setting-new-tabs :deep(.el-tabs__ink-bar) {
    background-color: #666eeb;
}
.setting-new-tabs :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: #F2F6FC;
}
</style>
